import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    container: {
      lineHeight: 1.375,
      paddingRight: '10px',
      [media.tablet]: {
        paddingRight: '75px',
      },
      [media.desktop]: {
        paddingRight: '75px',
      },

      [children('hr')]: {
        color: '#707070',
      },

      [children('h2')]: {
        marginBottom: 45,
      },
    },
    title: {
      fontSize: 25,
      marginBottom: 30,
    },

    speakerInfoContainer: {
      display: 'flex',
      marginBottom: 28,
    },

    speakerImageContainer: {
      flex: '0 0 111px',

      [media.tablet]: {
        flex: '0 0 260px',
      },
    },

    speakerIdentityInfo: {
      ':not(:only-child)': {
        padding: '0 20px',
      },

      [children('span')]: {
        display: 'block',
        fontWeight: 500,
      },

      [media.tablet]: {
        ':not(:only-child)': {
          padding: '0 30px',
        },
      },
    },

    speakerName: {
      fontSize: 24,
    },

    speakerTitle: {
      fontSize: 20,
    },

    experienceLabel: {
      fontWeight: 'bold',
    },

    speakerCompany: {
      fontSize: 20,
    },

    speakerNames: {
      fontSize: 18,
      fontWeight: 'bold',
      display: 'block',
    },

    speakerCompanies: {
      display: 'block',
      fontSize: 18,
      marginBottom: 25,
    },

    abstract: {},

    abstractDivider: {
      border: 'none',
      borderBottom: `1px solid ${palette.red}`,
      margin: '36px 0px',
      [media.desktop]: {
        margin: '50px 0px 40px 0px',
      },
    },

    speakerDivider: {
      border: 'none',
      borderBottom: `1px dashed ${palette.red}`,
      margin: '36px 0px',
      [media.desktop]: {
        margin: '50px 0px 40px 0px',
      },
    },

    experienceMobile: {
      [media.tablet]: {
        display: 'none',
      },
    },
    experienceTablet: {
      display: 'none',

      [media.tablet]: {
        marginTop: 10,
        display: 'block',
      },
    },
  });
};
